export default {
  scheduledSchedule (state) {
    return state.registeredSchedules.filter(elem => elem.status === 0)
  },
  awaitSchedule (state) {
    return state.registeredSchedules.filter(elem => elem.status === 5)
  },
  finishedSchedule (state) {
    return state.registeredSchedules.filter(elem => elem.status === 2)
  },
  canceledSchedule (state) {
    return state.registeredSchedules.filter(elem => elem.status === 1)
  },
  // allRegisteredSchedules (state) {
  //   return state.registeredSchedules.sort(function (a, b) {
  //     return b.controlNumber - a.controlNumber
  //   })
  // },
  searchSchedule (state) {
    return state.searchSchedule
  },
  scheduleEditing (state) {
    return state.scheduleEditing
  },
  reasons (state) {
    return state.reasons
  },
  sendEmailModal (state) {
    return state.sendEmailModal
  },
  selectedSchedule (state) {
    return state.selectedSchedule
  },
  registeredScheduleOrders (state) {
    return state.registeredScheduleOrders
  },
  alterDateModal (state) {
    return state.alterDateModal
  },
  scheduleOrdersModal (state) {
    return state.scheduleOrdersModal
  },
  scheduleDetailsModal (state) {
    return state.scheduleDetailsModal
  },
  timeScheduleModal (state) {
    return state.timeScheduleModal
  },
  loadingCondominium (state) {
    return state.loadingCondominium
  },
  searchCnpj (state) {
    return state.searchCnpj
  },
  errorSearchCnpj (state) {
    return state.errorSearchCnpj
  },
  loadingScheduleActions (state) {
    return state.loadingSaved || state.loadingCanceled || state.loadingFinished
  },
  disponibility (state) {
    return state.selectedSchedule.disponibility
  },
  disponibilityStart (state) {
    return state.selectedSchedule.disponibility.start
  },
  disponibilityEnd (state) {
    return state.selectedSchedule.disponibility.end
  },
  disponibilityInterval (state) {
    return state.selectedSchedule.disponibility.interval
  },
  alteredScheduleSaving (state) {
    return state.alteredScheduleSaving
  },
  alteredSchedule (state) {
    const idSelectedItens = state.selectedItens.map(elem => {
      return elem.id
    })
    const idAlteredState = state.alteredSchedule.itens.map(elem => {
      return elem.id
    })
    return JSON.stringify(state.selectedSchedule) !== JSON.stringify(state.alteredSchedule) ||
      JSON.stringify(idSelectedItens) !== JSON.stringify(idAlteredState)
  },
  alteredScheduleDateWarning (state) {
    if (state.selectedSchedule.id === '') {
      return false
    }
    return state.selectedSchedule.dates.length > 0 ? state.selectedSchedule.dates !== state.alteredSchedule.dates && state.selectedSchedule.sent : false
  },
  scheduleDone (state) {
    return state.selectedSchedule.status > 0
  },
  dateConfigModal (state) {
    return state.dateConfigModal
  },
  selectedScheduleIdChanged (state) {
    return state.selectedSchedule.id
  },
  selectedItens (state) {
    return state.selectedItens
  },
  selectedScheduleHasItens (state) {
    return typeof state.selectedSchedule.itens === 'undefined' || state.selectedSchedule.itens.length === 0
  },
  errorDisponibilityInterval (state) {
    return state.errorDisponibilityInterval
  },
  selectedScheduleCategory (state) {
    return state.selectedSchedule.category
  },
  hasCategorySelectedAndSelectedItens (state) {
    return ((state.selectedSchedule.category === '') || (state.selectedItens.length === 0))
  }
}



// WEBPACK FOOTER //
// ./src/store/agendamento/getters.js